module.exports = __webpack_public_path__ + "static/media/q_a_hover.9ec64599.svg";